import some from 'lodash/some';


export const getOccupiedPositionsForTile = ({sizex, sizey, col: baseColumn, row: baseRow})=> {
  const occupiedPositions = [];
  let col = baseColumn;
  let row = baseRow;
  while (row < baseRow + sizey) {
    while (col < baseColumn + sizex) {
      occupiedPositions.push({
        col: col,
        row: row
      });
      col += 1;
    }
    row += 1;
    col = baseColumn;
  }
  return occupiedPositions;
};


export const doesTileCollide = (tileA, tileB)=> {
  const positionsA = getOccupiedPositionsForTile(tileA);
  const positionsB = getOccupiedPositionsForTile(tileB);
  return some(positionsA, ({col: colA, row: rowA})=> {
    return some(positionsB, ({col: colB, row: rowB})=> {
      return colA === colB && rowA === rowB;
    });
  });
};

export const doesTileOverlapAnyTile = ({ col, row, sizex, sizey, gridPositions })=> {
  return some(gridPositions, (tilePosition)=> {
    return doesTileCollide({
      col,
      row,
      sizex,
      sizey
    }, tilePosition);
  });
};


export const getNextAvailablePosition = ({ sizex, sizey, gridPositions, columnCount })=> {
  // given a list of already occupied positions, and tile size
  // computes a possible next position for the tile
  let nextPosition = null;
  let col = 1;
  let row = 1;
  if (sizex > columnCount) {
    throw new Error('tile width must be less than or equal to max number of columns');
  }
  while (!nextPosition){
    if (doesTileOverlapAnyTile({ col, row, sizex, sizey, gridPositions })){
      if (col + sizex <= columnCount){
        col += 1;
      } else {
        col = 1;
        row += 1;
      }
    } else {
      nextPosition = {col, row, sizex, sizey};
    }
  }
  return nextPosition;
};


export const getNextAvailablePositionForTile = (tile, occupiedPositions, columnCount)=> {
  // tile must contains a sizex and a sizey
  // wraps getNextAvailablePosition, but will preserve non-positional object keys within the tile
  // also, will shrink the tile's width to conform to the column count if necessary
  let {sizex, sizey} = tile;
  if (sizex > columnCount) {
    // silently make the tile smaller if it is too wide
    sizex = columnCount;
  }
  const newPosition = getNextAvailablePosition({
    sizex, 
    sizey, 
    gridPositions: occupiedPositions, 
    columnCount: columnCount
  });
  return {
    ...tile,
    ...newPosition
  }
}


export const getNextUnboundedAvailablePosition = ({ sizex, sizey, gridPositions, columnCount })=> {
  // distinct from getNextAvailablePosition in that this tile will not be blocked
  // by other tiles from the bottom section of the page

  // also note that this has not been tested with sizex and sizey other than 1
  // for cases other than an empty lens
  var highestRow = 1;
  var selectedColumn = null;
  var selectedRow = null;
  var bestDepth = -1;
  var position;

  for(var i = 0; i< gridPositions.length; i++){
    if (gridPositions[i].row + gridPositions[i].sizey - 1 > highestRow){
      highestRow = gridPositions[i].row + gridPositions[i].sizey - 1;
    }
  }

  // make it sink to the lowest part contiguous with the empty bottom section,
  // prioritizing left over right

  for (var col=1; col<= columnCount; col++){
    var currentDepth = 0;
    while (!doesTileOverlapAnyTile({ col, row:highestRow-currentDepth, sizex, sizey, gridPositions }) && currentDepth < highestRow ){
      if(currentDepth > bestDepth){
        selectedColumn = col;
        selectedRow = highestRow - currentDepth;
        bestDepth = currentDepth;
      }
      currentDepth ++;
    } 
  }
  if (selectedColumn === null || selectedRow === null){
    selectedColumn = 1;
    selectedRow = highestRow + 1;
  }

  position = {
    row: selectedRow,
    col: selectedColumn,
    sizex: sizex,
    sizey: sizey
  };

  return position;
};
